import { getRenderingRef, forceUpdate, getElement } from '@stencil/core';
import { INTERNAL_ROUTER } from './globals.mjs';
import { InternalRouter } from './internalRouter.mjs';
import { logger } from './logger.mjs';

class PublicRouter {
    constructor() {
        this.init = (options) => {
            if (window[INTERNAL_ROUTER] != null) {
                logger.warn('Router has already been initialized');
                return;
            }
            window[INTERNAL_ROUTER] = new InternalRouter(options);
        };
        this.fillPath = (path, parameters) => {
            this.internal.updateInterestedParties();
            return this.internal.fillPath(path, parameters);
        };
    }
    get internal() {
        if (!window[INTERNAL_ROUTER]) {
            this.init();
        }
        return window[INTERNAL_ROUTER].with(getRenderingRef, forceUpdate, getElement);
    }
    get history() {
        this.internal.updateInterestedParties();
        return this.internal.history;
    }
    get location() {
        this.internal.updateInterestedParties();
        return this.internal.location;
    }
    get match() {
        return this.internal.match;
    }
    getUrl(url) {
        this.internal.updateInterestedParties();
        return this.internal.getUrl(url);
    }
    /** Push a location (navigate) to a path or location. `path` has baseUrl added. */
    get push() {
        return this.internal.push;
    }
    /** Replace the current location with a path or location. `path` has baseUrl added. */
    get replace() {
        return this.internal.replace;
    }
    /** Move back one page in the session history. It has the same effect as calling go(-1). If there is no previous page, this method call does nothing. */
    get goBack() {
        return this.internal.goBack;
    }
    /** Move forward one page in the session history. It has the same effect as calling go(1). If there is no next page, this method call does nothing. */
    get goForward() {
        return this.internal.goForward;
    }
    /** Load a specific page from the session history. You can use it to move forwards and backwards through the history depending on the value of a parameter. */
    get go() {
        return this.internal.go;
    }
}
const router = new PublicRouter();

export { PublicRouter, router };
